class ServiceDomains {
  static readonly Auth: string = 'auth';
  static readonly Category: string = 'category';
  static readonly Company: string = 'company';
  static readonly CreateUser: string = 'createUser';
  static readonly Employee: string = 'employee';
  static readonly Foreman: string = 'foreman';
  static readonly Hardware: string = 'hardware';
  static readonly Movement: string = 'movement';
  static readonly Project: string = 'project';
  static readonly Role: string = 'role';
  static readonly SubCategory: string = 'subCategory';
  static readonly User: string = 'user';
}

export default ServiceDomains;
